var render = function render(){var _vm=this,_c=_vm._self._c;return _c('document-link',{staticClass:"pretty-outing-link has-hover-background",attrs:{"document":_vm.outing,"target":"_blank"}},[_c('span',{staticClass:"has-text-normal"},[_vm._v(" "+_vm._s(_vm.outing.date_end)+" • "+_vm._s(_vm.outing.author.name)+" - ")]),_vm._v(" "),_c('document-title',{attrs:{"document":_vm.outing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }